import { X, Plus } from "lucide-react";
import { saveDefaultPrivacy, segBtn } from "@/lib/studioUtils";
import { PanelSection } from "./PanelSection";

// Public / unlisted / private, remembered as the default for next time.
export function VisibilityPicker({ privacy, setPrivacy }) {
  return (
    <div className="flex flex-col gap-1.5" data-testid="visibility-picker">
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-zinc-500">Visibility</span>
      <div className="grid grid-cols-3 border border-zinc-200 rounded-[4px] overflow-hidden divide-x divide-zinc-200 w-64">
        {[["public", "Public"], ["unlisted", "Unlisted"], ["private", "Private"]].map(([v, l]) => (
          <button key={v} type="button" onClick={() => { setPrivacy(v); saveDefaultPrivacy(v); }} data-testid={`visibility-${v}`}
            className={segBtn(privacy === v)}>{l}</button>
        ))}
      </div>
    </div>
  );
}

// Hashtags for this video: pulled from the original video, else your saved defaults.
export function DefaultHashtags({ defaultTags, setDefaultTags, defaultTagInput, setDefaultTagInput, saveTags, prefix = "details" }) {
  const addTag = () => {
    const t = defaultTagInput.replace(/^#/, "").trim();
    if (t && !defaultTags.includes(t)) { const next = [...defaultTags, t]; setDefaultTags(next); saveTags(next); }
    setDefaultTagInput("");
  };
  return (
    <PanelSection label="Hashtags" testId={`${prefix}-default-hashtags`}>
      <div className="flex gap-2">
        <input value={defaultTagInput} onChange={(e) => setDefaultTagInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addTag(); } }}
          data-testid={`${prefix}-tag-input`} placeholder="Add a hashtag"
          className="flex-1 min-w-0 bg-white border border-zinc-200 hover:border-zinc-300 rounded-[4px] px-3 py-2.5 text-sm text-zinc-900 outline-none focus:border-rose-500 transition-colors" />
        <button type="button" data-testid={`${prefix}-tag-add-btn`} onClick={addTag} title="Add hashtag"
          className="shrink-0 w-10 flex items-center justify-center border border-zinc-200 hover:border-rose-400 hover:text-rose-600 text-zinc-600 rounded-[4px] transition-colors"><Plus size={16} /></button>
      </div>
      <div className="flex flex-wrap gap-1.5" data-testid={`${prefix}-tags`}>
        {defaultTags.map((t, i) => (
          <span key={i} data-testid={`${prefix}-tag-chip-${i}`} className="flex items-center gap-1 bg-rose-50 border border-rose-200 text-rose-700 text-xs rounded-full pl-2.5 pr-1.5 py-1">
            #{t.replace(/^#/, "")}
            <button type="button" data-testid={`${prefix}-tag-remove-${i}`} className="hover:text-rose-900"
              onClick={() => { const next = defaultTags.filter((_, j) => j !== i); setDefaultTags(next); saveTags(next); }}><X size={12} /></button>
          </span>
        ))}
      </div>
    </PanelSection>
  );
}
